import { createActions } from "reduxsauce"

/* ------------- Types and Action Creators ------------- */

export const getCurrentPath = (state: any) => {
  const { pathname } = state.router.location
  return pathname
}

const { Types, Creators } = createActions({
  startup: null
})

export const StartupTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/redux/startup.redux.js